import { render } from "./TestimonialsIcon.vue?vue&type=template&id=8aca6ada"
import script from "./TestimonialsIcon.vue?vue&type=script&lang=js"
export * from "./TestimonialsIcon.vue?vue&type=script&lang=js"
script.render = render

export default script